import React from "react";
import "./detailFive.scss";
import topLogo from "../../assets/insight-top-logo.png"
import groupItem1 from "../../assets/group-item1.png";
import groupItem2 from "../../assets/group-item2.png";
import groupItem3 from "../../assets/group-item3.png";
import groupItem4 from "../../assets/group-item4.png";
import groupItem5 from "../../assets/group-item5.png";
import groupItem6 from "../../assets/group-item6.png";
import groupItem7 from "../../assets/group-item7.png";
import jtBlue from "../../assets/jtBlue.png";
import group1Item1 from "../../assets/group1-1.png"
import group1Item2 from "../../assets/group1-2.png"
import group1Item3 from "../../assets/group1-3.png"
import group1Item4 from "../../assets/group1-4.png"
import group2Item1 from "../../assets/group2-1.png"
import group2Item2 from "../../assets/group2-2.png"
import group2Item3 from "../../assets/group2-3.png"
import sbimg from "../../assets/sb-img.png"
import jtR from "../../assets/jt-r.png"
import patientImg from "../../assets/patient-img.png"
import bot from "../../assets/bot.png"
import dataView from "../../assets/data-view.png"
import OSS_URL from "../../constants/ossUrl";

class DetailFive extends React.Component {
    render() {
        return <div className="detail-5">
            <div className="top-logo">
                <img src={topLogo} alt="" />
            </div>
            <div className="title">
                <div className="line line-l"></div>
                <div className="title-txt">
                    <p>临床癫痫多模态数据库平台</p>
                    <p>融合所有数据，统一管理使用</p>
                </div>
                <div className="line line-r"></div>
            </div>
            <ul className="group">
                <li className="group-item">
                    <img src={groupItem1} />
                    <div className="group-desc">临床信息</div>
                </li>
                <li className="group-item">
                    <img src={groupItem2} />
                    <div className="group-desc">磁共振</div>
                </li>
                <li className="group-item">
                    <img src={groupItem3} />
                    <div className="group-desc">视频脑电图</div>
                </li>
                <li className="group-item">
                    <img src={groupItem4} />
                    <div className="group-desc">颅内脑电图</div>
                </li>
                <li className="group-item">
                    <img src={groupItem5} />
                    <div className="group-desc">脑磁图</div>
                </li>
                <li className="group-item">
                    <img src={groupItem6} />
                    <div className="group-desc">PET</div>
                </li>
                <li className="group-item">
                    <img src={groupItem7} />
                    <div className="group-desc">生物样本</div>
                </li>
            </ul>
            <img src={jtBlue} className="arrow-b" />
            <ul className="group-1">
                <li className="group-item"><img src={group1Item1} /></li>
                <li className="group-item"><img src={group1Item2} /></li>
                <li className="group-item"><img src={group1Item3} /></li>
                <li className="group-item"><img src={group1Item4} /></li>

                <li className="group-item group-item1"><img src={group2Item1} /></li>
                <li className="group-item group-item2"><img src={group2Item2} /></li>
                <li className="group-item group-item3"><img src={group2Item3} /></li>
            </ul>
            {/* <ul className="group-2">
                <li className="group-item group-item1"><img src={group2Item1} /></li>
                <li className="group-item group-item2"><img src={group2Item2} /></li>
                <li className="group-item group-item3"><img src={group2Item3} /></li>
            </ul> */}
            
            <div className="data-set">
                <div className="bg-line"></div>
                <div className="step-1">
                    <div className="title">
                        {/* <div className="line"></div> */}
                        <div className="title-bg">
                            <img src={bot} />
                        </div>
                    </div>
                    <div className="desc">
                        <p className="line-1">数据存储</p>
                        <p className="line-2">多重备份保障</p>
                        <p className="line-2">统一存储、统一调用</p>
                    </div>
                </div>
                {/* <img src={jtR} className="arrow-r"/> */}
                <div className="step-2">
                    <div className="title">
                        {/* <div className="line"></div> */}
                        <div className="title-bg">
                            <img src={dataView} />
                        </div>
                    </div>
                    <div className="desc">
                        <p className="line-1">数据查看</p>
                        <p className="line-2">影像、波形、视频、文本</p>
                        <p className="line-2">统一查看，融合显示</p>
                    </div>
                </div>
            </div>
            <div className="data-handle">
                <div className="step-1">
                    <div className="title">
                        <div className="line line-l"></div>
                        <div className="line line-r"></div>
                        <div className="title-txt">数据整合</div>
                        <div className="title-bg"></div>
                    </div>
                    <div className="desc">
                        以患者为中心严格权限控制
                    </div>
                    <img src={sbimg} />
                </div>
                <img src={jtR} className="arrow-r" />
                <div className="step-2">
                    <div className="title">
                        <div className="line line-l"></div>
                        <div className="line line-r"></div>
                        <div className="title-txt">患者检索</div>
                        <div className="title-bg"></div>
                    </div>
                    <div className="desc">
                        临床信息、数据情况多种条件组合
                    </div>
                    <img src={patientImg} />
                </div>
            </div>
        </div>  
    }
}

export default DetailFive;